import { useEffect } from 'react';
import { FormApi } from 'informed';

export const useFormValueMonitor = <T>(
  formRef: React.RefObject<FormApi<any>>,
  fieldName: string,
  onValueChange: (value: T) => void,
  intervalMs = 100
) => {
  useEffect(() => {
    if (!formRef.current) return;

    const checkValues = () => {
      const value = formRef.current?.getValue(fieldName);
      onValueChange(value);
    };

    // Initial check
    checkValues();

    // Set up interval to check for changes
    const interval = setInterval(checkValues, intervalMs);

    return () => clearInterval(interval);
  }, [formRef, fieldName, onValueChange, intervalMs]);
}; 